import { cn } from '@crehana/compass.ui/utils';

import { TransactionButtons } from '../../components';

type TransactionInfoProps = {
  className?: string;
};

const TransactionInfo: React.FC<TransactionInfoProps> = ({ className }) => {
  return (
    <div className={cn('tw-py-1.6 md:tw-px-1.6', className)}>
      <TransactionButtons />
    </div>
  );
};

export default TransactionInfo;
